import type { Scope } from "~/tools/impulse";

import { FormState } from "../_form-state";

/**
 * Converts the current state of the form into a unknown specification object.
 *
 * @param scope
 * @param form - The form state.
 * @returns An unknown value representing the widget `spec` field.
 */
export function formToUnknown(scope: Scope, form: FormState): unknown {
	/*
	 * TODO the react-impulse-form has a bug when returning verbose output
	 * https://github.com/owanturist/signal/issues/1071
	 *
	 * The workaround is to call verbose getOutput until the last ImpulseFormSwitch.
	 */

	const output = form.getOutput(scope, (_, verbose) => verbose);

	const widget = FormState.verboseOutputToSpec({
		...output,

		kind: {
			...output.kind,
			branches: {
				...output.kind.branches,
				metrics: {
					queries: form.fields.kind.branches.metrics.fields.queries.getOutput(scope, (_, verbose) => verbose),
					settings: {
						active: form.fields.kind.branches.metrics.fields.settings.active.getOutput(scope),
						branches: {
							TimeSeriesChart: form.fields.kind.branches.metrics.fields.settings.branches.TimeSeriesChart.getOutput(
								scope,
								(_, verbose) => verbose,
							),
							BarChart: form.fields.kind.branches.metrics.fields.settings.branches.BarChart.getOutput(
								scope,
								(_, verbose) => verbose,
							),
							GaugeChart: form.fields.kind.branches.metrics.fields.settings.branches.GaugeChart.getOutput(
								scope,
								(_, verbose) => verbose,
							),
							StatChart: form.fields.kind.branches.metrics.fields.settings.branches.StatChart.getOutput(
								scope,
								(_, verbose) => verbose,
							),
						},
					},
				},
			},
		},
	});

	// Use only the `spec` part in the editor
	return widget.toPerses().spec;
}
